import logo from "./logo.svg";
import "./App.css";
import React, { useState, useEffect } from "react";
import NavBar from "./components/NavBar";
import MainMint from "./components/MainMint";
import { init, useConnectWallet, useAccountCenter } from "@web3-onboard/react";
import * as services from "./services/Services";
import { ethers } from "ethers";
import coinbaseWalletModule from "@web3-onboard/coinbase";
import walletConnectModule from "@web3-onboard/walletconnect";
import injectedModule from "@web3-onboard/injected-wallets";
import Onboard from "@web3-onboard/core";
import Favicon from "./assets/favicon/favicon.png";

// Instantiate Modules
const coinbaseWalletSdk = coinbaseWalletModule();
const walletConnect = walletConnectModule();
const injected = injectedModule();

export const modules = [coinbaseWalletSdk, walletConnect, injected];

// Setup Web3ReactProvider
export const MAINNET_RPC_URL = `https://mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`;
const ROPSTEN_RPC_URL = `https://ropsten.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`;
const RINKEBY_RPC_URL = `https://rinkeby.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`;
const projectname = `${process.env.PROJECT}`;

const web3Onboard = init({
  wallets: modules, // created in previous step
  chains: [
    {
      id: "0x1", // chain ID must be in hexadecimel
      token: "ETH",
      namespace: "evm",
      label: "Ethereum",
      rpcUrl: MAINNET_RPC_URL,
    },
    // {
    //   id: "0x3",
    //   token: "tROP",
    //   namespace: "evm",
    //   label: "Ethereum Ropsten Testnet",
    //   rpcUrl: ROPSTEN_RPC_URL,
    // },
    // {
    //   id: "0x4",
    //   token: "rETH",
    //   namespace: "evm",
    //   label: "Ethereum Rinkeby Testnet",
    //   rpcUrl: RINKEBY_RPC_URL,
    // },
  ],
  appMetadata: {
    name: services.projectName,
    // TODO
    icon: Favicon,
    logo: Favicon,
    description: "Secured by Blocknative",
    recommendedInjectedWallets: [
      { name: "Coinbase", url: "https://wallet.coinbase.com/" },
      { name: "MetaMask", url: "https://metamask.io" },
    ],
  },
  accountCenter: {
    desktop: {
      position: "topRight",
      enabled: false,
      minimal: true,
    },
    mobile: {
      position: "topRight",
      enabled: false,
      minimal: true,
    },
  },
  notify: {
    desktop: {
      enabled: true,
      transactionHandler: (transaction) => {
        console.log({ transaction });
        if (transaction.eventCode === "txPool") {
          return {
            type: "success",
            message: "Your transaction to mint has been sent to the mempool",
          };
        }
      },
      position: "bottomRight",
    },
    mobile: {
      enabled: true,
      transactionHandler: (transaction) => {
        console.log({ transaction });
        if (transaction.eventCode === "txPool") {
          return {
            type: "success",
            message: "Your transaction to mint has been sent to the mempool",
          };
        }
      },
      position: "topRight",
    },
  },
});

function App() {
  const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();

  const [accounts, setAccounts] = useState([]);
  const contractAddress = services.contractAddress;
  const projectName = services.projectName;

  async function connectAccounts() {
    if (window.ethereum) {
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      setAccounts(accounts);
    }
  }

  const connectWallet = async () => {
    try {
      const wallets = await web3Onboard.connectWallet();
    } catch (error) {
      console.error(error);
    }
  };

  // create an ethers provider
  let ethersProvider;

  if (wallet) {
    ethersProvider = new ethers.providers.Web3Provider(wallet.provider, "any");
  }

  return (
    <div className="overlay">
      <div className="App">
        <NavBar
          projectName={projectName}
          accounts={wallet}
          setAccounts={setAccounts}
          contractAddress={contractAddress}
          connectAccounts={connectAccounts}
          connectWallet={connectWallet}
          wallet={wallet}
          connecting={connecting}
          connect={connect}
          disconnect={disconnect}
        />
        <MainMint
          projectName={projectName}
          accounts={wallet}
          setAccounts={setAccounts}
          contractAddress={contractAddress}
          connectAccounts={connectAccounts}
          connectWallet={connectWallet}
          wallet={wallet}
          connecting={connecting}
          connect={connect}
          disconnect={disconnect}
        />
      </div>
      <div className="wallpaper"></div>
    </div>
  );
}

export default App;
